import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getSantanderClabes = serviceBase({
  request: options => axiosClient.get('/santander/clabes', { params: options }),
  retry: 0
});

export const assignSantanderClabe = serviceBase({
  request: ({ clabe, clientId }) =>
    axiosClient.post(`/santander/clabes/assign/${clabe}`, { clientId }),
  retry: 0
});

export const unassignSantanderClabe = serviceBase({
  request: ({ clabe }) =>
    axiosClient.post(`/santander/clabes/unassign/${clabe}`),
  retry: 0
});

export const getSantanderPaymentReports = serviceBase({
  request: options =>
    axiosClient.get('/santander/payment-reports', { params: options }),
  retry: 0
});

export const getSantanderPaymentReportDetails = serviceBase({
  request: ({ santanderReportId, options }) =>
    axiosClient.get(
      `/santander/payment-reports/payments/${santanderReportId}/payments`,
      {
        params: options
      }
    ),
  retry: 0
});

export const reconcileSantanderPayment = serviceBase({
  request: ({ paymentId, reconcileData }) =>
    axiosClient.post(
      `/santander/payment-reports/payments/${paymentId}/reconcile`,
      reconcileData
    ),
  retry: 0
});

export const createUpfrontRent = serviceBase({
  request: ({ paymentId, contractId, continueBilling }) =>
    axiosClient.post(
      `/santander/payment-reports/payments/${paymentId}/create-upfront-rent`,
      { contractId, continueBilling }
    ),
  retry: 0
});

export const downloadSantanderDomiciledCollectionReportExcel = serviceBase({
  request: ({ reportId }) =>
    axiosClient.get(`/santander/payment-reports/${reportId}/excel`, {
      responseType: 'blob',
      timeout: 120000
    }),
  retry: 0
});

export const downloadSantanderDomiciledCollectionReportTxt = serviceBase({
  request: ({ reportId }) =>
    axiosClient.get(`/santander/payment-reports/${reportId}/txt`, {
      responseType: 'blob',
      timeout: 120000
    }),
  retry: 0
});

export const sendClabeToClient = serviceBase({
  request: ({ clientId }) =>
    axiosClient.post(`/santander/clabes/send-to-client/${clientId}`),
  retry: 0
});

export const exportAccumulatedAutomaticDebitReport = serviceBase({
  request: ({ startDate, endDate }) =>
    axiosClient.get(
      '/santander/payment-reports/automatic-debit/accumulated/export',
      { responseType: 'blob', params: { startDate, endDate }, timeout: 120000 }
    ),
  transformResponse: res => {
    try {
      const filename = 'reporte-cobros-domiciliados.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error(error);
    }
  },
  retry: 0
});

export const exportReferencedPaymentsReport = serviceBase({
  request: ({ startDate, endDate }) =>
    axiosClient.get('/santander/payment-reports/virtual-agreements/export', {
      responseType: 'blob',
      params: { startDate, endDate },
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'reporte-pagos-referenciados.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error(error);
    }
  },
  retry: 0
});
